function getExtension(file: File | Blob): string {
  if (file instanceof File) {
    const fileName = file.name;
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex !== -1) {
      return fileName.substring(dotIndex + 1).toLowerCase();
    }
    return "wav";
  } else {
    const mimeType = file.type;
    const mimeMap: Record<string, string> = {
      "audio/wav": "wav",
      "audio/x-wav": "wav",
      "audio/mpeg": "mp3",
      "audio/ogg": "ogg",
      "audio/aac": "aac",
      "audio/mp4": "m4a",
      "audio/x-m4a": "m4a",
      "video/mp4": "mp4",
      "video/webm": "webm",
      "video/mpeg": "mpeg",
    };
    return mimeMap[mimeType] || "wav";
  }
}

export default getExtension;
